import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {match} from 'react-router-dom';
import {Link} from 'react-router-dom';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
} from 'reactstrap';
import {CircleLoader} from 'react-spinners';
import {css} from '@emotion/core';

import {AppState} from '../Store';
import {DevelopmentTicket} from '../Services/TicketService';
import {Page} from '../Models';
import {
  loadDevelopmentCreator,
  setDevelopmentFilter,
  setDevelopmentVersion,
} from '../Store/Tickets/Actions';
import {DevelopmentFilter} from '../Store/Tickets/Types';

import LoadMore from '../Components/LoadMore';
import DevelopmentTicketPane from './DevelopmentTicketPane';

type TParams = {
}

interface DevelopmentProps {
  match: match<TParams>;

  currentFilter: DevelopmentFilter;
  currentVersion: string;
  tickets: Page<DevelopmentTicket>;
  authorised: boolean;
  versions: string[];
  loading: boolean;

  setPage: (page: number) => Promise<void>;
  setFilter: (filter: DevelopmentFilter) => void;
  setVersion: (version: string) => void;
}

function Development({
  currentFilter,
  currentVersion,
  tickets,
  authorised,
  versions,
  loading,

  setPage,
  setFilter,
  setVersion,
}: DevelopmentProps) {
  const path = window.location.pathname;
  const cleanPath = (path.includes('?') ? path.substring(0, path.lastIndexOf('?')) : path).replace(/\/+$/, '');
  const basePath = cleanPath.endsWith('development') ? 'development/' : '' ;

  const [versionOpen, setVersionOpen] = useState(false);

  const toggleVersion = () => setVersionOpen(!versionOpen);

  useEffect(() => {
    if (!authorised) {
      return;
    }

    if (currentVersion === '' && versions.length > 0) {
      setVersion(versions[0]);
    }

    setPage(1);
  }, [
    currentFilter,
    setPage,
    setVersion,
    authorised,
    currentVersion,
    versions,
  ]);

  useEffect(() => {
    let filter: DevelopmentFilter;
    if (cleanPath.endsWith('unreleased')) {
      filter = 'Unreleased';
    } else if (cleanPath.endsWith('version')) {
      filter = 'Version';
    } else {
      filter = 'All';
    }

    setFilter(filter);
  }, [cleanPath, setFilter]);

  const {page, pageCount} = tickets;

  return (
    <React.Fragment>
      <div className="world-category-area">
        <Nav tabs role="tablist">
          <NavItem className="title">Release Notes</NavItem>
          <NavItem className="nav-item"><Link className="nav-link" to={`${basePath}all`}>Released</Link></NavItem>
          <NavItem ><Link className="nav-link" to={`${basePath}unreleased`}>Upcoming</Link></NavItem>
          {currentFilter !== 'Version'
            ? <NavItem ><Link className="nav-link" to={`${basePath}version`}>By Version</Link></NavItem>
            : (
              <Dropdown nav isOpen={versionOpen} toggle={toggleVersion}>
                <DropdownToggle nav className="dropdown-toggle">{currentVersion}</DropdownToggle>
                <DropdownMenu>
                  {versions.map(v => <DropdownItem key={v} onClick={() => setVersion(v)}>{v}</DropdownItem>)}
                </DropdownMenu>
              </Dropdown>
            )}
        </Nav>
      </div>
      <div className="post-content-area mb-100">
        <div className="world-category-area">
          <div className="page-container">
            <div className="pages">
              <LoadMore digits={2} currentPage={page} pages={pageCount} callback={setPage} fragment={path} />
            </div>
          </div>
          <div className="tab-content">
            {loading
              ? <CircleLoader
                css={css`
                    display: block;
                    margin: 0 auto;
                  `}
              />
              : (
                tickets.items.map(t => {
                  return <DevelopmentTicketPane key={t.ticketNumber} ticket={t}/>;
                })
              )
            }
          </div>
        </div>
      </div>
      <div className="page-container">
        <div className="pages">
          <LoadMore digits={2} currentPage={page} pages={pageCount} callback={setPage}  fragment={path} />
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    currentFilter: state.tickets.development.currentFilter,
    currentPage: state.tickets.development.currentPage,
    currentVersion: state.tickets.development.currentVersion,
    tickets: state.tickets.development.list,
    authorised: state.auth.authorised,
    versions: state.tickets.development.versions,
    loading: state.tickets.loading,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    setPage: (page: number) => dispatch(loadDevelopmentCreator(page)),
    setFilter: (filter: DevelopmentFilter) => dispatch(setDevelopmentFilter(filter)),
    setVersion: (version: string) => dispatch(setDevelopmentVersion(version)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Development);
